'use client';

import { getCdnPath } from '@/src/utils/get-cdn-path';
import Image from 'next/image';
import Link from 'next/link';
import { ArrowRightIcon } from '../../ui/icons/icons';
import { MouseEventHandler, useContext } from 'react';
import { DeviceContext } from '@/src/store/contexts/device-context';
import { useRouter } from 'next/navigation';
import ImageWithFallback from '@/src/features/ui/image/image-with-fallback';

function PosWizardCard() {
  const { isMobile } = useContext(DeviceContext);
  const router = useRouter();

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault();
    const label = location.pathname === '/pos' ? 'POS Anasayfa' : 'POS Listeleme';

    const dataLayer = (window && 'dataLayer' in window && (window.dataLayer as any[])) || null;
    dataLayer?.push({
      event: 'GAEvent',
      eventCategory: 'Button Click',
      eventAction: 'POS Sihirbazi',
      eventLabel: `POS Shirbazını Dene - ${label}`,
    });

    router.push('/pos/sihirbaz/form?step=1');
  };

  if (isMobile)
    return (
      <Link href="/pos/sihirbaz/form?step=1" onClick={handleClick}>
        <div className="my-6 flex cursor-pointer rounded-[12px] border-[1px] border-[#8CE1B4] bg-[#F0FDF5] p-4">
          <div className="mr-4 flex flex-col">
            <div>
              <span className="mb-2 block text-[16px] font-semibold leading-[24px] -tracking-[0.01em]">
                POS Sihirbazı ile size uygun ürünleri kolayca öğrenin!
              </span>
              <span className="mb-4 block text-[12px] leading-[16px] text-[#737373]">
                Sihirbaza vereceğiniz yanıtlar ile şirketiniz için ideal ürünleri öğrenip, işletmenize değer
                katabilirsiniz.
              </span>
            </div>
            <div className="flex max-w-[194px] rounded-[6px] bg-[#06B559] px-[12px] py-[10px]">
              <span className="mr-auto text-[14px] font-semibold leading-[20px] text-[#fff]">POS Sihirbazını Dene</span>
              <ArrowRightIcon height={20} width={20} style={{ strokeWidth: 2, stroke: '#fff' }} />
            </div>
          </div>
          <div className="relative min-w-[92px]">
            <ImageWithFallback
              src={getCdnPath('/assets/pos/pos-wizard-mobile.png')}
              height={92}
              width={92}
              alt="pos sihirbazı"
              // loading="eage"
            />
          </div>
        </div>
      </Link>
    );
  else
    return (
      <Link href="/pos/sihirbaz/form?step=1" onClick={handleClick}>
        <div className="my-8 flex h-[140px] cursor-pointer items-center justify-between rounded-[12px] border-[1px] border-[#8CE1B4] bg-[#F0FDF5] px-8">
          <div className="flex max-w-[500px] flex-col">
            <span className="mb-2 text-[20px] font-semibold leading-[28px] -tracking-[0.01em]">
              POS Sihirbazı ile size uygun ürünleri kolayca öğrenin!
            </span>
            <span className="text-[14px] leading-[20px] text-[#737373]">
              Sihirbaza vereceğiniz yanıtlar ile şirketiniz için ideal ürünleri öğrenip, işletmenize değer
              katabilirsiniz.
            </span>
          </div>
          <div className="relative">
            <ImageWithFallback
              src={getCdnPath('/assets/pos/pos-wizard.png')}
              height={132}
              width={300}
              alt="pos sihirbazı"
              // loading="eager"
            />
          </div>
          <div className="flex min-w-[194px] rounded-[6px] bg-[#06B559] px-[12px] py-[10px]">
            <span className="mr-auto text-[14px] font-semibold leading-[20px] text-[#fff]">POS Sihirbazını Dene</span>
            <ArrowRightIcon height={20} width={20} style={{ strokeWidth: 2, stroke: '#fff' }} />
          </div>
        </div>
      </Link>
    );
}

export default PosWizardCard;
